import { call, put } from "redux-saga/effects";
import { GetDomainUsersByCompany } from "./domainUsersByCompanyTypes";
import { saveDomainUsersByCompany } from "./domainUsersByCompanyActions";
import { userApi } from "@/main/api";
import { AxiosError, AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getDomainUsersByCompanySaga(action: GetDomainUsersByCompany) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(userApi.getDomainUsersByCompany, action.payload);

		if (response.data.result) {
			yield put(saveDomainUsersByCompany(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveDomainUsersByCompany(null, true, resultError.messagesDataError));
		}
	}
}
